import { connect } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import { validWorkOrderStatusTypes } from "../../../Appconstants";
import { workOrderStatus } from "../../../redux/actions/API/dashboardActions";
import ProductionExtra from "./ProductionExtra";

interface IWorkOrderStatusItemsProps {
    workOrderStatus: Function;
    workOrderStatusState: any;
    workOrderStatusLoading: boolean;
    companyId: any;
}

const WORK_ORDER_STATUS_LABEL_MAP: Record<string, string> = {
    inplanning: "In Planning",
    ongoing: "Ongoing",
    onhold: "On Hold",
    completed: "Completed",
};

const WorkOrderStatusItems: React.FC<IWorkOrderStatusItemsProps> = ({
    companyId,
    workOrderStatus,
    workOrderStatusState,
    workOrderStatusLoading,
}) => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const typeIndexParam = Number(searchParams.get("typeIndex"));
    const hasValidTypeIndex = Number.isInteger(typeIndexParam) && typeIndexParam >= 0 && typeIndexParam < validWorkOrderStatusTypes.length;
    const selectedTypeIndex = hasValidTypeIndex ? typeIndexParam : 0;

    const orderedTypeIndexes = hasValidTypeIndex
        ? [selectedTypeIndex, ...validWorkOrderStatusTypes.map((_: string, index: number) => index).filter((index: number) => index !== selectedTypeIndex)]
        : validWorkOrderStatusTypes.map((_: string, index: number) => index);

    const dropdownOptions = orderedTypeIndexes.map((index: number) => {
        const type = validWorkOrderStatusTypes[index];
        return {
            label: WORK_ORDER_STATUS_LABEL_MAP[type] || type,
            value: index,
        };
    });

    useEffect(() => {
        const resolvedType = validWorkOrderStatusTypes[selectedTypeIndex] || validWorkOrderStatusTypes[0];

        workOrderStatus({
            companyId: Number(companyId),
            type: resolvedType,
        });
    }, [companyId, selectedTypeIndex, workOrderStatus]);

    const handleDropdownChange = (value: string | number) => {
        navigate(`/workOrderStatusItems?typeIndex=${Number(value)}`);
    };

    return (
        <ProductionExtra
            breadcrumbTitle="Work Order Status"
            dropdownOptions={dropdownOptions}
            loading={workOrderStatusLoading}
            selectedValue={selectedTypeIndex}
            handleDropdownChange={handleDropdownChange}
            tableData={workOrderStatusState}
        />
    );
};

const mapStateToProps = (state: any) => ({
    companyId: state.api.login?.data?.companyId,
    workOrderStatusState: state.api.getWorkOrderStatus?.workOrderStatus,
    workOrderStatusLoading: state.api.getWorkOrderStatus?.loading,
});

const mapDispatchToProps = (dispatch: any) => ({
    workOrderStatus: (payload: any) => dispatch(workOrderStatus(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(WorkOrderStatusItems);
